import { render, staticRenderFns } from "./BicPage.vue?vue&type=template&id=5d7058a4&"
import script from "./BicPage.vue?vue&type=script&lang=js&"
export * from "./BicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7058a4')) {
      api.createRecord('5d7058a4', component.options)
    } else {
      api.reload('5d7058a4', component.options)
    }
    module.hot.accept("./BicPage.vue?vue&type=template&id=5d7058a4&", function () {
      api.rerender('5d7058a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bic/BicPage.vue"
export default component.exports